import { DateUniversalBase } from '../../baseBtl/base/class/date-universal.class';

export class DateUniversal extends DateUniversalBase {}
